import React from "react";

import { Edit } from "react-admin";

import CampaignForm, { transform } from "./CampaignForm";

const CampaignEdit = (props) => (
	<Edit {...props} transform={transform} mutationMode="pessimistic">
		<CampaignForm />
	</Edit>
);

export default CampaignEdit;
